import { makeStyles } from 'tss-react/mui';

const useOAuthPasswordPanelStyles = makeStyles()((theme) => ({
  form: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
    width: '100%',
  },
  fields: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1.5),
  },
  actions: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1),
  },
}));

export default useOAuthPasswordPanelStyles;
